import React from "react";
import ProjectHeader from "../../Components/Projects/ProjectHeader";
import Projectsec2 from "../../Components/Projects/Projectsec2";
import Projectform from "../../Components/Projects/Projectform";
import Projectgallery from "../../Components/Projects/Projectgallery";
const Projects = () => {
    return(
        <>
        <ProjectHeader/>
        <Projectsec2/>
        <Projectgallery/>
        <Projectform/>
        </>
    );
}
export default Projects;